import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const ImgEmptyTemplate = () => {
  const { t } = useTranslation();

  return (
    <div className="img-center">
      <div style={{ textAlign: 'center' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 80 80"
        >
          <defs>
            <path
              id="g42jkdp1ja"
              d="M9 27h5c3.866 0 7 3.134 7 7v.5c0 3.59-2.91 6.5-6.5 6.5v2.15c0 .552-.448 1-1 1-.304 0-.591-.139-.78-.376L10.5 41H9c-3.866 0-7-3.134-7-7s3.134-7 7-7z"
            />
          </defs>
          <g fill="none" fillRule="evenodd">
            <g>
              <g>
                <g>
                  <g transform="translate(-1231 -465) translate(1103 184) translate(128 281) translate(9 11)">
                    <rect
                      width="26"
                      height="59"
                      fill="#FFF"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                      rx="5"
                    />
                    <path
                      fill="#BDBDBD"
                      fillOpacity=".3"
                      d="M5.5 4h7C13.88 4 15 5.12 15 6.5S13.88 9 12.5 9h-7C4.12 9 3 7.88 3 6.5S4.12 4 5.5 4zM18.5 4h2C21.88 4 23 5.12 23 6.5S21.88 9 20.5 9h-2C17.12 9 16 7.88 16 6.5S17.12 4 18.5 4z"
                    />
                  </g>
                  <g transform="translate(-1231 -465) translate(1103 184) translate(128 281)">
                    <use fill="#FFF" xlinkHref="#g42jkdp1ja" />
                    <path
                      fill="#BDBDBD"
                      fillOpacity=".3"
                      stroke="#BDBDBD"
                      strokeLinejoin="square"
                      strokeWidth="1.2"
                      d="M14 27.6c1.767 0 3.367.716 4.525 1.875C19.684 30.633 20.4 32.233 20.4 34h0v.5c0 1.59-.63 3.035-1.653 4.096-1.138 1.18-2.764 1.886-4.552 1.796h0l-.296 2.732-3.11-2.724H9c-1.767 0-3.367-.716-4.525-1.875C3.316 37.367 2.6 35.767 2.6 34c0-1.767.716-3.367 1.875-4.525C5.633 28.316 7.233 27.6 9 27.6h5z"
                    />
                  </g>
                  <g transform="translate(-1231 -465) translate(1103 184) translate(128 281) translate(32 21)">
                    <rect
                      width="46"
                      height="13"
                      fill="#FFF"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                      rx="6.5"
                    />
                    <rect
                      width="7"
                      height="7"
                      x="4"
                      y="3"
                      fill="#BDBDBD"
                      fillOpacity=".3"
                      rx="3.5"
                    />
                    <path
                      fill="#FFF"
                      fillOpacity=".3"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeOpacity=".3"
                      strokeWidth="2"
                      d="M13.5 4.5L39.5 4.5M13.5 8.5L23 8.5M26.5 8.5L30 8.5"
                    />
                  </g>
                  <g transform="translate(-1231 -465) translate(1103 184) translate(128 281) translate(24 37)">
                    <rect
                      width="46"
                      height="13"
                      fill="#FFF"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                      rx="6.5"
                    />
                    <rect
                      width="7"
                      height="7"
                      x="4"
                      y="3"
                      fill="#BDBDBD"
                      fillOpacity=".3"
                      rx="3.5"
                    />
                    <path
                      fill="#FFF"
                      fillOpacity=".3"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeOpacity=".3"
                      strokeWidth="2"
                      d="M13.5 4.5L39.5 4.5M13.5 8.5L23 8.5M26.5 8.5L30 8.5"
                    />
                  </g>
                  <g transform="translate(-1231 -465) translate(1103 184) translate(128 281) translate(16 53)">
                    <rect
                      width="46"
                      height="13"
                      fill="#FFF"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.2"
                      rx="6.5"
                    />
                    <rect
                      width="7"
                      height="7"
                      x="4"
                      y="3"
                      fill="#BDBDBD"
                      fillOpacity=".3"
                      rx="3.5"
                    />
                    <path
                      fill="#FFF"
                      fillOpacity=".3"
                      stroke="#BDBDBD"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeOpacity=".3"
                      strokeWidth="2"
                      d="M13.5 4.5L39.5 4.5M13.5 8.5L23 8.5M26.5 8.5L30 8.5"
                    />
                  </g>
                  <path
                    d="M0 0H80V80H0z"
                    transform="translate(-1231 -465) translate(1103 184) translate(128 281)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <div style={{ marginTop: '8px', textAlign: 'center' }}>
          <Typography variant="body1">{t('TemplateEmpty')}</Typography>
          <Typography
            variant="body1"
            style={{ color: color.$10, width: '241px', marginTop: '8px' }}
          >
            {t('TemplateEmptyDesc')}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ImgEmptyTemplate;
